module.exports = "/assets/site/images/horgasz.jpg?a9cd7fc55c2cc0f3b845c78c2bd76039";